import { assetFileUrl, type SupportedLocale } from "@playbrain/content-types"

/**
 * Where the sample report is served from when the CMS has nothing to say.
 *
 * The report is uploaded per locale under PLAYDATA → Settings, so a newer one
 * replaces this without a deploy. These remain as the fallback for a stage
 * whose settings record is missing or unpublished — and they are the reason
 * uploading is not a migration: a stage that has never had one uploaded keeps
 * serving the file that shipped with the bundle.
 */
const sampleReportUrls: Record<SupportedLocale, string> = {
  en: "https://s3.ap-northeast-1.amazonaws.com/playdata.gg/playdata-sample-report-en.pdf",
  ja: "https://s3.ap-northeast-1.amazonaws.com/playdata.gg/playdata-sample-report-ja.pdf",
}

/**
 * The settings value may be either an object key in this stage's asset bucket,
 * which is what an upload stores, or an absolute URL, which is what the field
 * held while it was a URL box. Both resolve here, so neither needed migrating.
 */
export function playdataSampleReportUrl(locale: SupportedLocale, configured?: string | null): string {
  const stage = import.meta.env.PUBLIC_STAGE || import.meta.env.VITE_PUBLIC_STAGE
  return assetFileUrl(configured, stage) ?? sampleReportUrls[locale]
}
